import api from './api';

const adminNgoService = {
  // Get all NGOs (admin)
  getNgos: async () => {
    try {
      const response = await api.get('/partners/admin/ngos/');
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch NGOs'
      };
    }
  },

  // Get NGO by ID
  getNgoById: async (id) => {
    try {
      const response = await api.get(`/partners/admin/ngos/${id}/`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch NGO'
      };
    }
  },

  // Create NGO
  createNgo: async (data) => {
    try {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });

      const response = await api.post('/partners/admin/ngos/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Failed to create NGO'
      };
    }
  },

  // Update NGO
  updateNgo: async (id, data) => {
    try {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });

      const response = await api.patch(`/partners/admin/ngos/${id}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || 'Failed to update NGO'
      };
    }
  },

  // Delete NGO
  deleteNgo: async (id) => {
    try {
      await api.delete(`/partners/admin/ngos/${id}/`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to delete NGO'
      };
    }
  }
};

export default adminNgoService;
